import { CircularProgressbar } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';

const CycleChart = ({ percentage }: { percentage: number }) => {
  return (
    <div className="w-[100px] h-[90px] flex flex-col items-center">
      <div className="w-[80%]">
        <CircularProgressbar
          value={percentage}
          text={`${percentage}%`}
          styles={{
            path: {
              stroke: '#6A7C95',
              strokeLinecap: 'butt',
              transition: 'stroke-dashoffset 0.5s ease 0s',
              strokeWidth: 8,
            },
            trail: {
              stroke: '#d6d6d6',
              strokeLinecap: 'butt',
              strokeWidth: 8,
            },
            text: {
              fill: '#000000',
              fontSize: '28px',
              fontWeight: 'bold',
            },
          }}
        />
      </div>
      <p className="-mt-7 text-[11px] text-[#6A7C95] font-[500]">
        Cycle
      </p>
    </div>
  );
};

export default CycleChart;
